import { Component } from '@angular/core';

@Component({
    templateUrl: './lostbid-help.component.html',
    standalone: false
})
export class LostBidHelpComponent { }
